import React from 'react'
import styled from 'styled-components'
import { Button, InputNumber, Typography } from 'antd'
import { SendOutlined } from '@ant-design/icons'
import { Web3Button, Web3Modal } from '@web3modal/react'
import { useBridge } from './useBridge'
import { Step } from '../create/components/Step'
import { WalletInfoWrapper } from '../create/components/ConnectWallet'
import { ethereumClient } from '../../hooks/useWallet'
import { Loading } from '../create/components/Loading'

const { Text } = Typography

export const Bridge = () => {
  const { amount, inputChange, bridgeTokens, address, chain, data, isLoading, tx } =
    useBridge()
  if (isLoading) {
    return <Loading tx={tx} loadingText="Bridging GNO to Chiado" />
  }
  return (
    <Step title="Step 2 of 2: Bridge GNO from Goerli">
      <>
        <AddressButtonWrapperStyled>
          {address && (
            <WalletInfoWrapper>
              <p>{chain.name}</p>
              <p>{address}</p>
              {data && (
                <p>
                  Balance: {data.formatted} {data.symbol}
                </p>
              )}
            </WalletInfoWrapper>
          )}
          <Web3ButtonWrapperStyled>
            <Web3Button />
            <Web3Modal
              projectId="9a2846ab319d3e074b744395e11c7fae"
              ethereumClient={ethereumClient}
            />
          </Web3ButtonWrapperStyled>
        </AddressButtonWrapperStyled>
        <PageWrapper>
          <TransferColumnWrapper>
            <ColumnStyled>
              <Text type="secondary">From</Text>
              <Typography.Title level={5} style={{ margin: 0 }}>
                GNO Goerli
              </Typography.Title>
              <div>
                <InputNumber
                  prefix="Goerli GNO"
                  style={{ width: '100%' }}
                  value={amount}
                  onChange={inputChange}
                  min={0}
                  max={data ? parseFloat(data.formatted) : 0}
                />
              </div>
            </ColumnStyled>
            <Button
              style={{ margin: '0 16px' }}
              type="primary"
              shape="round"
              icon={<SendOutlined />}
              size="large"
              onClick={bridgeTokens}
            >
              Transfer
            </Button>
            <ColumnStyled>
              <Text type="secondary">To</Text>
              <Typography.Title level={5} style={{ margin: 0 }}>
                GNO Chiado
              </Typography.Title>
              <div>
                <InputNumber
                  prefix="Chiado GNO"
                  style={{ width: '100%' }}
                  min={0}
                  value={amount}
                  disabled
                />
              </div>
            </ColumnStyled>
          </TransferColumnWrapper>
        </PageWrapper>
      </>
    </Step>
  )
}

const PageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 200px);
`

const TransferColumnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const ColumnStyled = styled.div`
  border: 1px solid #1c77ff;
  padding: 8px;
  border-radius: 10px;
`
const Web3ButtonWrapperStyled = styled.div`
  display: flex;
`
const AddressButtonWrapperStyled = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`
